import { useSetRecoilState } from 'recoil';
import { allMessages } from '~/state/toasts';

const useAddToast = () => {
  const addNewToast = useSetRecoilState(allMessages);
  return addNewToast;
};

export default useAddToast;
